
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/view-base/abpbase";
import { RoleDto, UpdateUserRoleInput } from "@/api/service-proxies";

import { userService } from "@/api/userService";

@Component({
  name: "select-record-face-templete",
  components: {},
})
export default class UpdateRole extends AbpBase {
  @Prop({ type: Boolean, default: false }) value!: boolean;
  @Prop({ type: Number, default: 0 }) userId!: number;

  roles: RoleDto[] = [];
  checkList = [];

  @Watch("value")
  watchValue() {
    if (this.isDialogVisible && this.userId) {
      this.getRoles();
    }
  }

  get isDialogVisible() {
    return this.value;
  }

  set isDialogVisible(value: boolean) {
    this.$emit("input", value);
  }

  created() {}

  async getRoles() {
    var result = await userService.getUserRoles(this.userId);

    this.roles = result.items;

    this.checkList = this.roles.filter((p) => p.isChecked).map((p) => p.id);
  }

  async done() {
    await userService.updateUserRoles(
      new UpdateUserRoleInput({ userId: this.userId, roleIds: this.checkList })
    );
    this.$notify.success("修改成功");
    this.$emit("input", false);
  }
}
